<template>
  <b-form-group id="confirm-password-input-group"
    :class="'form-group-password-comp ' + form_group_class + ' row w-100 mx-0'" :label="label ? label :$t('confirm_password') + '*'"
    label-for="confirm_password" :confirm_password="confirm_password" :label-class="form_label_class" >
    <p :class="error_message_class" v-if="invalid_confirm_password">
      {{ $t('invalid_confirm_password') }}
    </p>
    <p :class="error_message_class" v-if="invalid_correct_confirm_password">
      {{ $t('validate_password_match') }}
    </p>
    <b-row class="w-100 mx-0 px-0">
      <b-col class="pl-0">
        <b-input-group class="input-group-password input-group-validate-confirm-password">
          <b-form-input class=" form-control-validate-password" :class="input_class" id="confirm_password"
            v-model="_confirm_password" :type="show_password ? 'text' : 'password'"
            :placeholder="$t('placeholder_confirm_password')" required @focus="focusPasswordField"
            @blur="blurPasswordField"></b-form-input>
          <b-input-group-append>
            <b-button @click="show_password = !show_password"><font-awesome-icon icon="fa-solid fa-eye"
                v-if="!show_password" />
              <font-awesome-icon icon="fa-solid fa-eye-slash" v-else /></b-button>
          </b-input-group-append>
        </b-input-group>

        <ul :class="validation_ul_class">
          <li v-bind:class="{ is_valid: match_passwords }">
            {{ $t('validate_password_match') }}
          </li>
        </ul>
      </b-col>
    </b-row>
  </b-form-group>
</template> 

<script>
import $ from 'jquery'
export default {
  name: "ConfirmPasswordValidation",
  props: [
    "label",
    "input_class",
    "password",
    "confirm_password",
    "invalid_confirm_password",
    "invalid_correct_confirm_password",
    "validation_ul_class",
    "form_group_class",
    "form_label_class",
    "error_message_class"
  ],
  data() {
    return {
      match_passwords: false,
      show_password: false,
    };
  },
  mounted() { },
  computed: {
    _confirm_password: {
      get() {
        return this.confirm_password;
      },
      set(value) {
        this.$emit("update:confirm_password", value);
      },
    },
  },
  watch: {
    _confirm_password(newval, oldval) {
      if (this.password != this._confirm_password) {
        this.match_passwords = false;
      } else {
        this.match_passwords = true;
      }
    },
  },
  methods: {

    focusPasswordField() {
      $('.input-group-validate-confirm-password').addClass('focus')
    },
    blurPasswordField() {
      $('.input-group-validate-confirm-password').removeClass('focus')
    }
  }
};
</script>
  


// WEBPACK FOOTER //
// src/components/Inputs/ConfirmPasswordValidation.vue